// Influencer configuration data
window.influencerConfig = {
  "zarena": {
    name: "Zarena",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/Zarena_ZA_logo_afe18de1-26de-4ab5-848b-92cde3c5db4d.png?v=1671024204",
    instagramHandle: "@zarenaro"
  },
  // Template for new influencers
  "example": {
    name: "Influencer Name",
    profilePic: "https://cdn.shopify.com/s/files/1/0573/1565/5835/files/default_profile_pic.jpg?v=1743520442",
    instagramHandle: "@example"
  }
};